import React, { useEffect, useState } from "react";
import { Col, Row, Form } from "antd";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import "./../../styles/modal.css";
import MeshBillModal from "../Items/Modal/Index";
import MeshBillButton from "../Items/Button/Index";
// const MeshBillSelect = lazy(() => import("../Items/Select/Index"));
// const MeshBillModal = lazy(() => import("../Items/Modal/Index"));
// const MeshBillButton = lazy(() => import("../Items/Button/Index"));

const DisconnectApiConnectedUserModal: React.FC<ConnectUserGraphModalProp> = ({
  show,
  handleClose,
  intPkNasDeviceID,
  user,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<RequestToDisconnectApiConnectedUser>(
    "mikronoc/requestToDisconnectPPPoEUser",
    true
  );

  const [disconnectResultApi, disconnectResultApiResponse] =
    useAxiosPost<RequestToDisconnectApiConnectedUser>(
      "mikronoc/checkDisconnectedPPPoEUserResponse",
      true
    );
  const [isMessageDisplayed, setIsMessageDisplayed] = useState<boolean>(false);
  const onFinish = (values: any) => {
    setIsLoading(true);
    const dataToSend: RequestToDisconnectApiConnectedUser = {
      intPkNasDeviceID: intPkNasDeviceID,
      id: user.id,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(false);
        }, 2500);
        // startIntervalHandler(30000);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  const startIntervalHandler = (timeout: number) => {
    const interval = setInterval(() => {
      disconnectResultApi({
        intPkNasDeviceID: intPkNasDeviceID,
        id: user.id,
      });
    }, 3000);
    setTimeout(() => {
      clearInterval(interval);
    }, timeout);
  };

  useEffect(() => {
    if (disconnectResultApiResponse !== null) {
      const responseData: any = disconnectResultApiResponse.responseData;
      console.log({ responseData });
      const { data } = responseData;
      if (data && data?.response === true && isMessageDisplayed === false) {
        setIsMessageDisplayed(true);
        openNotification(
          "success",
          "Success",
          `User Disconnected Successfully`
        );
        setTimeout(() => {
          handleClose(true);
        }, 3000);
      }
    }
  }, [disconnectResultApiResponse]);
  return (
    <>
      <MeshBillModal
        title="Disconnect User"
        headerStyle={{
          backgroundColor: "var(--primary-background-color)",
          color: "var(--primary-text-color)",
          fontSize: "16px",
          fontWeight: "var(--fw-700)",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          if (apiLoading || isLoading) {
            return;
          }
          handleClose(false);
        }}
      >
        {contextHolder}

        <Row>
          <Col
            span={24}
            className="meshbill-create-record-modal-form-container"
          >
            <Form
              //   requiredMark={true}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="updateStaffStatusForm"
              form={form}
            >
              <div className="confirmation-message-container">
                <label className="modal-confirmation-message">
                  Are you sure , you want to disconnect this user?
                </label>
              </div>
              <Form.Item>
                <MeshBillButton
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Disconnect"
                  disabled={apiLoading || isLoading}
                  // icon={<FiPlusCircle />}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </MeshBillModal>
    </>
  );
};
export default DisconnectApiConnectedUserModal;
